import React from 'react';

export default class  DeviceSelector extends React.PureComponent {
    
    constructor(props) {
        super(props);
        this.state = {
            selected: window.sdk.videoconf().mediaDevices().getCurrentDeviceId(this.props.kind),
			devices: this.props.devices,
            disabled: false,                    
        };
        
        //if(window.sdk.session().isExtern() && this.props.kind == 'audioinput') 
          //  this.state.disabled = true;

          
        
        if(this.props.kind == 'videoinput' && window.sdk.videoconf().mediaDevices().getStream().getVideoTracks().length < 1)
            this.state.disabled = true;
        if(this.props.kind == 'audioinput' && window.sdk.videoconf().mediaDevices().getStream().getAudioTracks().length < 1)
            this.state.disabled = true;
        
        if(this.props.kind == 'audioinput' && window.sdk.videoconf().isMicMute())
            this.state.disabled = true;
        if(this.props.kind == 'videoinput' && window.sdk.videoconf().isWebcamHide())
            this.state.disabled = true;
    }

    async componentDidMount() {
        if(this.props.kind == 'audioinput' && window.sdk.session().isExtern()) {
            this.toggleDisable();
        }

        
        
    }

    /*async componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.devices) !== JSON.stringify(prevProps.devices)) {
            this.setState({
                devices: this.props.devices
            })
        }
    }*/
    
    updateDevice = (e) => {
        let deviceId = e.target.value;
        this.setState({
            selected: deviceId
        });
        if(this.props.kind != 'audiooutput')
            window.sdk.videoconf().mediaDevices().update(this.props.kind, deviceId);
        else
            window.sdk.videoconf().mediaDevices().setAudioOutputDeviceId(deviceId);
    }

    toggleDisable = () => {
        this.setState({
            disabled: !this.state.disabled
        });
        switch(this.props.kind){
            case 'audioinput':
                window.sdk.videoconf().toggleMicMute();
                break;
            case 'videoinput':
                window.sdk.videoconf().toggleWebcamHide();
                break;            
            
        }
    }
    
    render() {
		if (!this.props.devices)
			return null;

        let icon = false;
        switch(this.props.kind) {
            case 'audioinput':
                icon = 'icon-mic';
                break;
            case 'audiooutput':
                icon = 'icon-speaker';
                break;
            case 'videoinput':
                icon = 'icon-cam';
                break;
        }
        if ( icon && this.state.disabled ) {
            icon += '-off';
        }
		
        return (
            <div className={"device-selector" + (icon !== false ? " device-selector--iconed" : "") + (this.props.prefix ? " device-selector--prefixed" : "")}>
                <label className="device-selector__label">{ this.props.label }</label>
                {(typeof this.props.prefix === "string" && this.props.prefix) && <i className={"device-selector__prefix " + this.props.prefix} />}
                <div className="device-selector__container"><select className="device-selector__input" onChange={ this.updateDevice } value={ this.state.selected }>
                    { this.props.devices.map((device, i) => (
                        <option key={'option-'+i} value={ device.deviceId }>{device.label}</option>
                    ))}
                </select></div>
                {(icon !== false && !this.props.disableButton) && <button className={'device-selector__disable' + (this.state.disabled ? ' device-selector__disable--disabled' : '')} onClick={this.toggleDisable}>
                    <i className={icon}></i>
                </button>}
            </div>
        );
    }
    
}